import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth/msalConfig';
import { MasqueradeProvider } from './auth/MasqueradeContext';
import { TestModeProvider } from './auth/TestModeContext';
import { PortalSettingsProvider } from './auth/PortalSettingsContext';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { NewRequestPage } from './pages/NewRequestPage';
import { ApprovalsPage } from './pages/ApprovalsPage';
import { ScopePage } from './pages/ScopePage';
import { AdminPage } from './pages/AdminPage';
import { AuditPage }        from './pages/AuditPage';
import { LoginHistoryPage } from './pages/LoginHistoryPage';
import UATPage from './pages/UATPage';
import './styles/globals.css';

const msalInstance = new PublicClientApplication(msalConfig);

fetch('/api/ping').catch(() => {});

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <MasqueradeProvider>
          <TestModeProvider>
            <PortalSettingsProvider>
              <BrowserRouter>
                <AppShell>
                  <Routes>
                    <Route path="/"             element={<DashboardPage />} />
                    <Route path="/projects"     element={<ProjectsPage />} />
                    <Route path="/projects/:id" element={<ProjectDetailPage />} />
                    <Route path="/new"          element={<NewRequestPage />} />
                    <Route path="/approvals"    element={<ApprovalsPage />} />
                    <Route path="/scope"        element={<ScopePage />} />
                    <Route path="/admin"        element={<AdminPage />} />
                    <Route path="/audit"         element={<AuditPage />} />
                    <Route path="/login-history" element={<LoginHistoryPage />} />
                    <Route path="/uat"         element={<UATPage />} />
                    <Route path="*"            element={<Navigate to="/" replace />} />
                  </Routes>
                </AppShell>
              </BrowserRouter>
            </PortalSettingsProvider>
          </TestModeProvider>
        </MasqueradeProvider>
      </AuthenticatedTemplate>
    </MsalProvider>
  );
}